import { EntityTypes } from "../../EntityTypes";
import { IProfessionalSituationResource } from "../../professional-situations";
import { ITrainingPhaseResource } from "../../training-phases";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { ITrainingPhaseProfessionalSituationResource } from "../types";

export interface ITrainingPhaseProfessionalSituationCreateMutationParameters {
    trainingPhase: RelationalValue<ITrainingPhaseResource>;
    professionalSituation: RelationalValue<IProfessionalSituationResource>;
    startHour: number;
    endHour: number;
    hasPlanningSuggestion: boolean;
}

export type ITrainingPhaseProfessionalSituationCreateMutationResult = ITrainingPhaseProfessionalSituationResource;

export const trainingPhaseProfessionalSituationCreateMutation: IApiMutationFunction<
    ITrainingPhaseProfessionalSituationCreateMutationParameters
> = ({ trainingPhase, professionalSituation, startHour, endHour, hasPlanningSuggestion }) => ({
    method: "POST",
    url: "/training_phase_professional_situations",
    data: {
        trainingPhase: mapRelationalValueAsIRI(EntityTypes.TRAINING_PHASE, trainingPhase),
        professionalSituation: mapRelationalValueAsIRI(EntityTypes.PROFESSIONAL_SITUATION, professionalSituation),
        startHour,
        endHour,
        hasPlanningSuggestion,
    },
});

export const useTrainingPhaseProfessionalSituationCreateMutation = createApiMutationHook<
    ITrainingPhaseProfessionalSituationCreateMutationParameters,
    ITrainingPhaseProfessionalSituationCreateMutationResult
>(trainingPhaseProfessionalSituationCreateMutation);
